import React, { ReactNode, MouseEvent } from "react";
import ChildNavItem from "../../Sidebar/ChildNavItem";
import { EnumPaths } from "../../../utils/navigation";
import images from "../../../images";
import NavItem from "../../Sidebar/NavItem";
import history from "../../../history";
import { Display } from "../../../components/OperatorCustomization";

interface Props {
  children: ReactNode;
}

const CustomUsersTwoColumns = ({ children }: Props): JSX.Element => {
  const goToPage = (
    e: MouseEvent<HTMLDivElement | HTMLAnchorElement>,
    path: string
  ) => {
    e.preventDefault();
    history.push(path);
  };

  const isActive = (path: string): boolean => {
    return history.location.pathname === path;
  };

  return (
    <main className="customUsersTwoColLayout h-screen flex overflow-hidden pt-20">
      <div className="hidden md:flex md:flex-shrink-0 w-2/12">
        <div className="flex flex-col w-full bg-neutral-300">
          <div className="h-0 flex-1 flex flex-col overflow-y-auto w-full">
            <nav className="flex-1">
              <div className="py-5 divide-gray-200">
                <NavItem
                  id="menu_users"
                  index={0}
                  icon={images.nav_pilot_2}
                  text="navbar.menu.users"
                  withoutTitle
                >
                  <ChildNavItem
                    index={0}
                    text="navbar.menu.users"
                    onClick={e =>
                      goToPage(e, `/${EnumPaths.ROOT}/${EnumPaths.USERS}`)
                    }
                    isActive={isActive(`/${EnumPaths.ROOT}/${EnumPaths.USERS}`)}
                    icon="userIcon"
                  />
                  <Display paths={["feature.enterprise"]}>
                    <ChildNavItem
                      index={1}
                      text="navbar.menu.enterprises"
                      onClick={e =>
                        goToPage(
                          e,
                          `/${EnumPaths.ROOT}/${EnumPaths.USERS}/${EnumPaths.ENTERPRISE}`
                        )
                      }
                      isActive={isActive(
                        `/${EnumPaths.ROOT}/${EnumPaths.USERS}/${EnumPaths.ENTERPRISE}`
                      )}
                      icon="caseIcon"
                    />
                    <ChildNavItem
                      index={2}
                      text="navbar.menu.spaces"
                      onClick={e =>
                        goToPage(
                          e,
                          `/${EnumPaths.ROOT}/${EnumPaths.USERS}/${EnumPaths.SPACES}`
                        )
                      }
                      isActive={isActive(
                        `/${EnumPaths.ROOT}/${EnumPaths.USERS}/${EnumPaths.SPACES}`
                      )}
                      icon="deskIcon"
                    />
                  </Display>
                </NavItem>
              </div>
            </nav>
          </div>
        </div>
      </div>
      <div className="flex flex-col w-0 flex-1 overflow-hidden">
        <div
          id="scroll-container"
          className="m-0 flex-1 relative z-0 overflow-y-auto focus:outline-none bg-white"
        >
          <div className="dashboard-wrapper">{children}</div>
        </div>
      </div>
    </main>
  );
};

export default CustomUsersTwoColumns;
